// Auto-extracted emoji/icon data — edit here, import in EmojiPicker.tsx

// ─── Emoji data ────────────────────────────────────────────────────────────────

export const EMOJI_CATEGORIES = {
  Recent: ["😁"],
  "Hands & Gestures": [
    "👋", "🤚", "🖐️", "✋", "🖖", "👌", "🤌", "🤏", "✌️", "🤞",
    "🫰", "🤟", "🤘", "🤙", "👈", "👉", "👆", "🖕", "👇", "☝️",
    "🫵", "👍", "👎", "✊", "👊", "🤛", "🤜", "👏", "🙌", "🫶",
    "👐", "🤲", "🤝", "🙏",
  ],
  People: [
    "😀", "😃", "😄", "😁", "😆", "😅", "🤣", "😂", "🙂", "🙃",
    "🫠", "😉", "😊", "😇", "🥰", "😍", "🤩", "😘", "😗", "☺️",
    "😚", "😙", "🥲", "😋", "😛", "😜", "🤪", "😝", "🤑", "🤗",
    "🤭", "🫢", "🫣", "🤫", "🤔", "🫡", "🤐", "🤨", "😐", "😑",
    "😶", "🫥", "😶‍🌫️", "😏", "😒", "🙄", "😬", "😮‍💨", "🤥", "😌",
    "😔", "😪", "🤤", "😴", "😷", "🤒", "🤕", "🤢", "🤮", "🤧",
    "🥵", "🥶", "🥴", "😵", "😵‍💫", "🤯", "🤠", "🥳", "🥸", "😎",
    "🤓", "🧐",
  ],
  "Animals & Nature": [
    "🐶", "🐱", "🐭", "🐹", "🐰", "🦊", "🐻", "🐼", "🐨", "🐯",
    "🦁", "🐮", "🐷", "🐸", "🐵", "🐔", "🐧", "🐦", "🐤", "🦆",
    "🦅", "🦉", "🦇", "🐺", "🐗", "🐴", "🦄", "🐝", "🪱", "🐛",
    "🦋", "🐌", "🐞", "🐜", "🪰", "🪲", "🪳", "🦟", "🦗", "🌸",
    "🌺", "🌻", "🌷", "🌹", "🥀", "🏵️", "🌲", "🌳", "🌴", "🌱",
    "🌿", "☘️", "🍀", "🍃", "🍂", "🍁", "🪴",
  ],
  "Food & Drink": [
    "🍎", "🍊", "🍋", "🍌", "🍉", "🍇", "🍓", "🫐", "🍈", "🍒",
    "🍑", "🥭", "🍍", "🥥", "🥝", "🍅", "🥑", "🍆", "🥔", "🥕",
    "🌽", "🥒", "🥬", "🫑", "🥦", "🧄", "🧅", "🍄", "🥜", "🫘",
    "🍞", "🥐", "🥖", "🥨", "🧀", "🥚", "🍳", "🥓", "🥞", "🧇",
    "🍗", "🍖", "🍕", "🍔", "🌭", "🥪", "🌮", "🌯", "🫔", "🥙",
    "🧆", "🍿", "🧈", "🧂", "☕", "🍵", "🥤", "🧃", "🧋", "🍺",
  ],
  Activities: [
    "⚽", "🏀", "🏈", "⚾", "🥎", "🎾", "🏐", "🏉", "🥏", "🎱",
    "🪀", "🏓", "🏸", "🏒", "🏑", "🥍", "🏏", "🪃", "🥅", "⛳",
    "🪁", "🏹", "🎣", "🤿", "🥊", "🥋", "🎽", "🛹", "🛼", "🛷",
    "⛸️", "🥌", "🎿", "⛷️", "🏂", "🪂", "🏋️", "🤼", "🤸", "⛹️",
    "🤺", "🤾", "🏌️", "🏇", "🧘", "🏄", "🏊", "🤽", "🚣", "🧗",
    "🚴", "🚵", "🎯", "🎮", "🎰", "🎲", "🧩", "♟️", "🎭", "🎨",
  ],
  "Travel & Places": [
    "🚗", "🚕", "🚙", "🚌", "🚎", "🏎️", "🚓", "🚑", "🚒", "🚐",
    "🛻", "🚚", "🚛", "🚜", "🛵", "🏍️", "🛺", "🚲", "🛴", "🚏",
    "🛣️", "🛤️", "⛽", "🚨", "🚥", "🚦", "🛑", "🚧", "⚓", "⛵",
    "🛶", "🚤", "🛳️", "⛴️", "🛥️", "🚢", "✈️", "🛩️", "🛫", "🛬",
    "🪂", "💺", "🚁", "🚟", "🚠", "🚡", "🛰️", "🚀", "🛸", "🏠",
    "🏡", "🏢", "🏣", "🏤", "🏥", "🏦", "🏨", "🏩", "🏪", "🏫",
  ],
  Objects: [
    "⌚", "📱", "📲", "💻", "⌨️", "🖥️", "🖨️", "🖱️", "🖲️", "🕹️",
    "🗜️", "💾", "💿", "📀", "📼", "📷", "📸", "📹", "🎥", "📽️",
    "🎞️", "📞", "☎️", "📟", "📠", "📺", "📻", "🎙️", "🎚️", "🎛️",
    "🧭", "⏱️", "⏲️", "⏰", "🕰️", "⌛", "⏳", "📡", "🔋", "🔌",
    "💡", "🔦", "🕯️", "🪔", "🧯", "🛢️", "💸", "💵", "💴", "💶",
    "💷", "🪙", "💰", "💳", "💎", "⚖️", "🪜", "🧰", "🪛", "🔧",
    "📚", "📖", "📝", "✏️", "✒️", "🖊️", "🖋️", "📔", "📕", "📗",
  ],
  Symbols: [
    "❤️", "🧡", "💛", "💚", "💙", "💜", "🖤", "🤍", "🤎", "💔",
    "❤️‍🔥", "❤️‍🩹", "💕", "💞", "💓", "💗", "💖", "💘", "💝", "💟",
    "☮️", "✝️", "☪️", "🕉️", "☸️", "✡️", "🔯", "🕎", "☯️", "☦️",
    "⚛️", "🛐", "♈", "♉", "♊", "♋", "♌", "♍", "♎", "♏",
    "♐", "♑", "♒", "♓", "⛎", "🔀", "🔁", "🔂", "▶️", "⏩",
    "🔥", "⭐", "🌟", "✨", "⚡", "💥", "💫", "🌈", "☀️", "🌙",
  ],
};

// ─── Icon data (bundled offline via @iconify-json/* packages) ─────────────────

export const UI_ICONS = [
  "tabler:alarm-filled", "tabler:alert-circle-filled", "tabler:alert-triangle-filled", "tabler:analyze-filled",
  "tabler:apps-filled", "tabler:archive-filled", "tabler:arrow-big-down-filled", "tabler:arrow-big-left-filled",
  "tabler:arrow-big-right-filled", "tabler:arrow-big-up-filled", "tabler:arrow-down-circle-filled", "tabler:arrow-left-circle-filled",
  "tabler:arrow-right-circle-filled", "tabler:arrow-up-circle-filled", "tabler:article-filled", "tabler:asset-filled",
  "tabler:award-filled", "tabler:badge-filled", "tabler:balloon-filled", "tabler:barbell-filled",
  "tabler:basket-filled", "tabler:bath-filled", "tabler:battery-filled", "tabler:bed-filled",
  "tabler:beer-filled", "tabler:bell-filled", "tabler:bike-filled", "tabler:binoculars-filled",
  "tabler:blob-filled", "tabler:bolt-filled", "tabler:bomb-filled", "tabler:bone-filled",
  "tabler:book-filled", "tabler:bookmark-filled", "tabler:bowl-filled", "tabler:bread-filled",
  "tabler:briefcase-filled", "tabler:bubble-filled", "tabler:bubble-text-filled", "tabler:bug-filled",
  "tabler:bulb-filled", "tabler:bus-filled", "tabler:butterfly-filled", "tabler:cactus-filled",
  "tabler:calculator-filled", "tabler:calendar-event-filled", "tabler:calendar-filled", "tabler:calendar-month-filled",
  "tabler:calendar-week-filled", "tabler:camera-filled", "tabler:campfire-filled", "tabler:car-filled",
  "tabler:cards-filled", "tabler:category-filled", "tabler:chart-area-filled", "tabler:chart-area-line-filled",
  "tabler:chart-bubble-filled", "tabler:chart-candle-filled", "tabler:chart-donut-filled", "tabler:chart-dots-2-filled",
  "tabler:chart-dots-3-filled", "tabler:chart-dots-filled", "tabler:chart-funnel-filled", "tabler:chart-grid-dots-filled",
  "tabler:chart-pie-2-filled", "tabler:chart-pie-3-filled", "tabler:chart-pie-4-filled", "tabler:chart-pie-filled",
  "tabler:check-filled", "tabler:chess-filled", "tabler:circle-check-filled", "tabler:circle-filled",
  "tabler:circle-x-filled", "tabler:clipboard-check-filled", "tabler:clipboard-filled", "tabler:clipboard-list-filled",
  "tabler:clock-filled", "tabler:cloud-filled", "tabler:coin-filled", "tabler:compass-filled",
  "tabler:confetti-filled", "tabler:copy-filled", "tabler:credit-card-filled", "tabler:crown-filled",
  "tabler:current-location-filled", "tabler:dashboard-filled", "tabler:database-filled", "tabler:device-desktop-filled",
  "tabler:device-mobile-filled", "tabler:device-tablet-filled", "tabler:device-tv-filled", "tabler:device-watch-filled",
  "tabler:diamond-filled", "tabler:dice-filled", "tabler:directions-filled", "tabler:disc-filled",
  "tabler:discount-check-filled", "tabler:discount-filled", "tabler:download-filled", "tabler:droplet-filled",
  "tabler:edit-filled", "tabler:egg-filled", "tabler:elevator-filled", "tabler:exchange-filled",
  "tabler:exclamation-circle-filled", "tabler:eye-filled", "tabler:eyeglass-filled", "tabler:feather-filled",
  "tabler:ferry-filled", "tabler:file-analytics-filled", "tabler:file-check-filled", "tabler:file-description-filled",
  "tabler:file-download-filled", "tabler:file-filled", "tabler:file-text-filled", "tabler:file-upload-filled",
  "tabler:filter-filled", "tabler:flag-filled", "tabler:flame-filled", "tabler:flower-filled",
  "tabler:folder-filled", "tabler:folder-open-filled", "tabler:gauge-filled", "tabler:ghost-filled",
  "tabler:gift-filled", "tabler:glass-filled", "tabler:globe-filled", "tabler:golf-filled",
  "tabler:graph-filled", "tabler:headphones-filled", "tabler:headset-filled", "tabler:heart-filled",
  "tabler:helicopter-filled", "tabler:help-circle-filled", "tabler:hexagon-filled", "tabler:home-filled",
  "tabler:hourglass-filled", "tabler:id-filled", "tabler:info-circle-filled", "tabler:key-filled",
  "tabler:keyboard-filled", "tabler:layout-board-filled", "tabler:layout-cards-filled", "tabler:layout-dashboard-filled",
  "tabler:layout-filled", "tabler:layout-grid-filled", "tabler:layout-kanban-filled", "tabler:layout-list-filled",
  "tabler:leaf-filled", "tabler:lemon-2-filled", "tabler:library-filled", "tabler:lifebuoy-filled",
  "tabler:link-filled", "tabler:list-check-filled", "tabler:list-details-filled", "tabler:list-filled",
  "tabler:live-photo-filled", "tabler:location-filled", "tabler:lock-filled", "tabler:magnet-filled",
  "tabler:mail-filled", "tabler:mail-opened-filled", "tabler:man-filled", "tabler:map-pin-filled",
  "tabler:medical-cross-filled", "tabler:message-circle-filled", "tabler:message-filled", "tabler:messages-filled",
  "tabler:microphone-filled", "tabler:microscope-filled", "tabler:microwave-filled", "tabler:moon-filled",
  "tabler:mountain-filled", "tabler:mouse-filled", "tabler:mushroom-filled", "tabler:navigation-filled",
  "tabler:octagon-filled", "tabler:paint-filled", "tabler:palette-filled", "tabler:parking-circle-filled",
  "tabler:pencil-filled", "tabler:phone-call-filled", "tabler:phone-check-filled", "tabler:phone-filled",
  "tabler:photo-filled", "tabler:pig-filled", "tabler:pill-filled", "tabler:pin-filled",
  "tabler:pinned-filled", "tabler:pizza-filled", "tabler:plane-filled", "tabler:player-pause-filled",
  "tabler:player-play-filled", "tabler:player-record-filled", "tabler:player-skip-back-filled", "tabler:player-skip-forward-filled",
  "tabler:player-stop-filled", "tabler:playlist-filled", "tabler:plus-filled", "tabler:poo-filled",
  "tabler:presentation-filled", "tabler:puzzle-filled", "tabler:radar-filled", "tabler:receipt-filled",
  "tabler:report-analytics-filled", "tabler:satellite-filled", "tabler:scale-filled", "tabler:school-filled",
  "tabler:search-filled", "tabler:seedling-filled", "tabler:send-filled", "tabler:settings-filled",
  "tabler:shield-check-filled", "tabler:shield-filled", "tabler:shirt-filled", "tabler:shopping-cart-filled",
  "tabler:sitemap-filled", "tabler:sort-ascending-2-filled", "tabler:sort-descending-2-filled", "tabler:sparkles-filled",
  "tabler:spider-filled", "tabler:stack-filled", "tabler:star-filled", "tabler:steering-wheel-filled",
  "tabler:sun-filled", "tabler:table-filled", "tabler:tag-filled", "tabler:template-filled",
  "tabler:thumb-down-filled", "tabler:thumb-up-filled", "tabler:ticket-filled", "tabler:timeline-event-filled",
  "tabler:toggle-left-filled", "tabler:toggle-right-filled", "tabler:train-filled", "tabler:trash-filled",
  "tabler:trophy-filled", "tabler:truck-filled", "tabler:umbrella-filled", "tabler:user-filled",
  "tabler:versions-filled", "tabler:video-filled", "tabler:woman-filled", "tabler:world-filled",
  "tabler:writing-filled", "tabler:yin-yang-filled", "tabler:zoom-in-filled", "tabler:zoom-out-filled",
  "bxs:add-to-queue", "bxs:adjust", "bxs:adjust-alt", "bxs:alarm-add",
  "bxs:alarm-exclamation", "bxs:alarm-snooze", "bxs:album", "bxs:ambulance", "bxs:angry", "bxs:arch", "bxs:baby-carriage",
  "bxs:ball", "bxs:band-aid", "bxs:bank", "bxs:baseball", "bxs:bath", "bxs:battery-charging", "bxs:been-here", "bxs:bell-ring",
  "bxs:bible", "bxs:blanket", "bxs:bolt-circle", "bxs:bong", "bxs:book-add", "bxs:book-reader", "bxs:bowl-hot", "bxs:bowling-ball",
  "bxs:brain", "bxs:bullseye", "bxs:buoy", "bxs:bus-school", "bxs:business", "bxs:cabinet", "bxs:cable-car", "bxs:cake",
  "bxs:camera-movie", "bxs:camera-plus", "bxs:car-battery", "bxs:car-crash", "bxs:car-garage", "bxs:car-mechanic", "bxs:car-wash", "bxs:castle",
  "bxs:cat", "bxs:cctv", "bxs:chat", "bxs:check-circle", "bxs:check-shield", "bxs:check-square", "bxs:cheese", "bxs:chess",
  "bxs:chevron-down", "bxs:chevron-down-circle", "bxs:chevron-down-square", "bxs:chevron-left",
  "bxs:chevron-left-circle", "bxs:chevron-left-square", "bxs:chevron-right", "bxs:chevron-right-circle",
  "bxs:chevron-right-square", "bxs:chevron-up", "bxs:chevron-up-circle", "bxs:chevron-up-square",
  "bxs:circle-half", "bxs:circle-quarter", "bxs:circle-three-quarter", "bxs:city", "bxs:clinic", "bxs:cloud-download", "bxs:cloud-lightning", "bxs:cloud-rain",
  "bxs:cloud-upload", "bxs:coffee-alt", "bxs:coffee-togo", "bxs:collection", "bxs:color-fill", "bxs:comment", "bxs:comment-add",
  "bxs:comment-check", "bxs:comment-detail", "bxs:comment-dots", "bxs:comment-edit", "bxs:comment-error", "bxs:comment-minus", "bxs:comment-x", "bxs:confused",
  "bxs:contact", "bxs:conversation", "bxs:cookie", "bxs:cool", "bxs:copyright", "bxs:credit-card-front", "bxs:cricket-ball", "bxs:customize",
  "bxs:cylinder", "bxs:detail", "bxs:dice-1", "bxs:dice-2", "bxs:dice-3", "bxs:dice-4", "bxs:dice-6", "bxs:direction-left",
  "bxs:direction-right", "bxs:directions", "bxs:discount", "bxs:dish", "bxs:dislike", "bxs:dizzy", "bxs:dock-bottom", "bxs:dock-left",
  "bxs:dock-right", "bxs:dock-top", "bxs:dog", "bxs:donate-blood", "bxs:donate-heart", "bxs:door-open", "bxs:down-arrow", "bxs:down-arrow-alt",
  "bxs:downvote", "bxs:drink", "bxs:dryer", "bxs:edit-location", "bxs:error", "bxs:error-alt", "bxs:error-circle", "bxs:ev-station",
  "bxs:exit", "bxs:eyedropper", "bxs:face", "bxs:face-mask", "bxs:factory", "bxs:fast-forward-circle", "bxs:file-find",
  "bxs:file-jpg", "bxs:film", "bxs:first-aid", "bxs:flag-checkered",
  "bxs:florist", "bxs:food-menu", "bxs:fridge", "bxs:game", "bxs:gas-pump", "bxs:graduation", "bxs:grid", "bxs:group",
  "bxs:guitar-amp", "bxs:hand", "bxs:hand-down", "bxs:hand-left", "bxs:hand-right", "bxs:hand-up", "bxs:happy", "bxs:happy-alt",
  "bxs:happy-beaming", "bxs:happy-heart-eyes", "bxs:hard-hat", "bxs:heart-circle",
  "bxs:heart-square", "bxs:help-circle", "bxs:hide", "bxs:home-alt-2", "bxs:home-circle", "bxs:home-heart", "bxs:home-smile", "bxs:hot",
  "bxs:hotel", "bxs:hourglass-bottom", "bxs:hourglass-top", "bxs:image-add", "bxs:info-square", "bxs:injection", "bxs:invader", "bxs:joystick",
  "bxs:joystick-alt", "bxs:joystick-button", "bxs:keyboard", "bxs:label", "bxs:landmark", "bxs:laugh", "bxs:layer", "bxs:layer-minus",
  "bxs:layer-plus", "bxs:left-arrow", "bxs:left-arrow-alt", "bxs:left-arrow-circle",
  "bxs:left-arrow-square", "bxs:left-down-arrow-circle", "bxs:left-top-arrow-circle", "bxs:lemon",
  "bxs:like", "bxs:location-plus", "bxs:lock-alt", "bxs:lock-open-alt", "bxs:log-in", "bxs:log-in-circle", "bxs:log-out", "bxs:log-out-circle",
  "bxs:low-vision", "bxs:magic-wand", "bxs:magnet", "bxs:mask", "bxs:megaphone", "bxs:meh", "bxs:meh-alt", "bxs:meh-blank",
  "bxs:memory-card", "bxs:message", "bxs:message-add", "bxs:message-alt",
  "bxs:message-alt-add", "bxs:message-alt-check", "bxs:message-alt-detail", "bxs:message-alt-dots",
  "bxs:message-alt-edit", "bxs:message-alt-error", "bxs:message-alt-minus", "bxs:message-alt-x",
  "bxs:message-check", "bxs:message-detail", "bxs:message-dots", "bxs:message-edit",
  "bxs:message-error", "bxs:message-minus", "bxs:message-rounded", "bxs:message-rounded-add",
  "bxs:message-rounded-check", "bxs:message-rounded-detail", "bxs:message-rounded-dots", "bxs:message-rounded-edit",
  "bxs:message-rounded-error", "bxs:message-rounded-minus", "bxs:message-rounded-x", "bxs:message-square",
  "bxs:message-square-add", "bxs:message-square-check", "bxs:message-square-detail", "bxs:message-square-dots",
  "bxs:message-square-edit", "bxs:message-square-error", "bxs:message-square-minus", "bxs:message-square-x",
  "bxs:message-x", "bxs:meteor", "bxs:microchip", "bxs:microphone-alt", "bxs:minus-circle", "bxs:minus-square", "bxs:mobile-vibration", "bxs:mouse-alt",
  "bxs:movie-play", "bxs:music", "bxs:network-chart", "bxs:news", "bxs:no-entry", "bxs:note", "bxs:notepad", "bxs:notification",
  "bxs:notification-off", "bxs:objects-horizontal-center", "bxs:objects-horizontal-left", "bxs:objects-horizontal-right",
  "bxs:objects-vertical-bottom", "bxs:objects-vertical-center", "bxs:objects-vertical-top", "bxs:offer",
  "bxs:package", "bxs:paint", "bxs:paint-roll", "bxs:paper-plane", "bxs:parking", "bxs:party", "bxs:paste", "bxs:pear",
  "bxs:pen", "bxs:phone-call", "bxs:phone-incoming", "bxs:phone-outgoing", "bxs:photo-album", "bxs:piano", "bxs:pie-chart", "bxs:pie-chart-alt",
  "bxs:pizza", "bxs:plane-alt", "bxs:plane-land", "bxs:plane-take-off", "bxs:planet", "bxs:playlist", "bxs:plug", "bxs:pointer",
  "bxs:polygon", "bxs:popsicle", "bxs:purchase-tag", "bxs:purchase-tag-alt",
  "bxs:pyramid", "bxs:quote-alt-left", "bxs:quote-alt-right", "bxs:quote-left", "bxs:quote-right", "bxs:quote-single-left", "bxs:quote-single-right", "bxs:radiation",
  "bxs:radio", "bxs:rectangle", "bxs:registered", "bxs:rename", "bxs:report", "bxs:rewind-circle", "bxs:right-arrow", "bxs:right-arrow-alt",
  "bxs:right-arrow-circle", "bxs:right-arrow-square", "bxs:right-down-arrow-circle", "bxs:right-top-arrow-circle",
  "bxs:rocket", "bxs:ruler", "bxs:sad", "bxs:select-multiple", "bxs:server", "bxs:shapes", "bxs:share", "bxs:share-alt",
  "bxs:shield-alt-2", "bxs:shield-minus", "bxs:shield-plus", "bxs:shield-x", "bxs:ship", "bxs:shocked", "bxs:shopping-bag", "bxs:shopping-bag-alt",
  "bxs:shopping-bags", "bxs:show", "bxs:shower", "bxs:skip-next-circle", "bxs:skip-previous-circle", "bxs:skull", "bxs:sleepy", "bxs:slideshow",
  "bxs:smile", "bxs:sort-alt", "bxs:spa", "bxs:speaker", "bxs:spray-can", "bxs:spreadsheet", "bxs:square", "bxs:square-rounded",
  "bxs:star-half", "bxs:sticker", "bxs:store", "bxs:store-alt",
  "bxs:sushi", "bxs:t-shirt", "bxs:tag-x", "bxs:taxi", "bxs:tennis-ball", "bxs:terminal", "bxs:thermometer", "bxs:time",
  "bxs:tired", "bxs:to-top", "bxs:toggle-left", "bxs:toggle-right", "bxs:tone", "bxs:torch", "bxs:traffic", "bxs:traffic-barrier",
  "bxs:traffic-cone", "bxs:train", "bxs:tree", "bxs:tree-alt", "bxs:truck", "bxs:tv", "bxs:universal-access", "bxs:up-arrow",
  "bxs:up-arrow-alt", "bxs:up-arrow-circle", "bxs:up-arrow-square", "bxs:upside-down",
  "bxs:upvote", "bxs:user-account", "bxs:user-badge", "bxs:user-check", "bxs:user-detail", "bxs:user-minus", "bxs:user-pin", "bxs:user-plus",
  "bxs:user-voice", "bxs:vector", "bxs:vial", "bxs:video-off", "bxs:video-plus", "bxs:video-recording", "bxs:videos", "bxs:virus",
  "bxs:virus-block", "bxs:volume", "bxs:washer", "bxs:watch", "bxs:watch-alt", "bxs:webcam", "bxs:widget", "bxs:window-alt",
  "bxs:wine", "bxs:wink-smile", "bxs:wink-tongue", "bxs:wrench", "bxs:x-circle", "bxs:x-square", "bxs:yin-yang", "bxs:zap",
  "bxs:zoom-in", "bxs:zoom-out","bx:run", "bx:walk", "bx:cycling", "tabler:run", "tabler:users-group", "tabler:circle-caret-right-filled"
];

export const FLAT_COLOR_ICONS = [
  "about", "add-database", "add-image", "advertising",
  "alarm-clock", "android-os", "approval", "assistant",
  "audio-file", "bar-chart", "bearish", "bookmark",
  "broken-link", "bullish", "business", "business-contact",
  "businessman", "calendar", "camera", "cancel",
  "candle-sticks", "checkmark", "collaboration", "collect",
  "combo-chart", "command-line", "conference-call", "contacts",
  "currency-exchange", "cursor", "data-backup", "data-configuration",
  "data-encryption", "data-protection", "data-recovery", "data-sheet",
  "database", "department", "diploma-1", "diploma-2",
  "disapprove", "document", "donate", "doughnut-chart",
  "download", "edit-image", "electronics", "empty-trash",
  "end-call", "expired", "export", "factory",
  "faq", "feedback", "file", "flash-on",
  "folder", "full-trash", "gallery", "generic-sorting-asc",
  "generic-sorting-desc", "globe", "graduation-cap", "high-priority",
  "home", "idea", "image-file", "import",
  "in-transit", "info", "inspection", "invite",
  "key", "like-placeholder", "line-chart", "lock",
  "low-priority", "make-decision", "manager", "mind-map",
  "money-transfer", "multiple-devices", "music", "neutral-decision",
  "news", "next", "night-landscape", "no-idea",
  "ok", "online-support", "opened-folder", "org-unit",
  "package", "paid", "panorama", "parallel-tasks",
  "phone", "pie-chart", "planner", "podium-with-speaker",
  "portrait-mode", "positive-dynamic", "previous", "print",
  "privacy", "process", "questions", "rating",
  "reading", "reading-ebook", "refresh", "remove-image",
  "right-up", "sales-performance", "search", "selfie",
  "serial-tasks", "services", "settings", "share",
  "shipped", "shop", "smartphone-tablet", "sports-mode",
  "stack-of-photos", "statistics", "support", "synchronize",
  "template", "timeline", "todo-list", "touchscreen-smartphone",
  "tree-structure", "two-smartphones", "unlock", "upload",
  "video-call", "video-file", "video-projector", "view-details",
  "voice-presentation", "voicemail", "webcam", "workflow"
];

// ─── Emoji name lookup (generated from emoji-picker-react data) ───────────────
// Maps emoji character → space-separated keywords for search

export const EMOJI_NAMES: Record<string, string> = {
  // Hand & gesture emojis — searchable by the gesture/hand name so a user
  // typing "wave" or "hand" finds them.
  "👋": "wave waving hand hello hi greeting",
  "🤚": "raised back of hand stop",
  "🖐️": "raised hand with fingers splayed",
  "✋": "raised hand high five stop",
  "🖖": "vulcan salute spock",
  "👌": "ok hand okay perfect",
  "🤌": "pinched fingers italian",
  "🤏": "pinching hand small",
  "✌️": "victory peace",
  "🤞": "crossed fingers hope luck",
  "🫰": "hand with index finger and thumb crossed money love",
  "🤟": "love you gesture",
  "🤘": "sign of the horns rock",
  "🤙": "call me hand shaka",
  "👈": "backhand index pointing left",
  "👉": "backhand index pointing right",
  "👆": "backhand index pointing up",
  "🖕": "middle finger",
  "👇": "backhand index pointing down",
  "☝️": "index finger pointing up",
  "🫵": "index pointing at viewer you",
  "👍": "thumbs up like good",
  "👎": "thumbs down dislike bad",
  "✊": "raised fist solidarity",
  "👊": "oncoming fist punch",
  "🤛": "left facing fist",
  "🤜": "right facing fist",
  "👏": "clapping hands applause",
  "🙌": "raising hands celebration",
  "🫶": "heart hands love",
  "👐": "open hands",
  "🤲": "palms up together prayer",
  "🤝": "handshake deal agreement",
  "🙏": "folded hands please thanks prayer",
  "😁": "grin grinning face with smiling eyes",
  "😀": "grinning grinning face",
  "😃": "smiley smiling face with open mouth",
  "😄": "smile smiling face with open mouth and smiling eyes",
  "😆": "laughing satisfied smiling face with open mouth and tightly-closed eyes",
  "😅": "sweat smile smiling face with open mouth and cold sweat",
  "🤣": "rolling on the floor laughing",
  "😂": "joy face with tears of joy",
  "🙂": "slightly smiling face",
  "🙃": "upside-down face upside down face",
  "🫠": "melting face",
  "😉": "wink winking face",
  "😊": "blush smiling face with smiling eyes",
  "😇": "innocent smiling face with halo",
  "🥰": "smiling face with 3 hearts smiling face with smiling eyes and three hearts",
  "😍": "heart eyes smiling face with heart-shaped eyes",
  "🤩": "star-struck grinning face with star eyes",
  "😘": "kissing heart face throwing a kiss",
  "😗": "kissing kissing face",
  "😚": "kissing closed eyes kissing face with closed eyes",
  "😙": "kissing smiling eyes kissing face with smiling eyes",
  "🥲": "smiling face with tear",
  "😋": "yum face savouring delicious food",
  "😛": "stuck out tongue face with stuck-out tongue",
  "😜": "stuck out tongue winking eye face with stuck-out tongue and winking eye",
  "🤪": "zany face grinning face with one large and one small eye",
  "😝": "stuck out tongue closed eyes face with stuck-out tongue and tightly-closed eyes",
  "🤑": "money-mouth face money mouth face",
  "🤗": "hugging face",
  "🤭": "face with hand over mouth smiling face with smiling eyes and hand covering mouth",
  "🫢": "face with open eyes and hand over mouth",
  "🫣": "face with peeking eye",
  "🤫": "shushing face face with finger covering closed lips",
  "🤔": "thinking face",
  "🫡": "saluting face",
  "🤐": "zipper-mouth face zipper mouth face",
  "🤨": "face with raised eyebrow face with one eyebrow raised",
  "😐": "neutral face",
  "😑": "expressionless expressionless face",
  "😶": "no mouth face without mouth",
  "🫥": "dotted line face",
  "😏": "smirk smirking face",
  "😒": "unamused unamused face",
  "🙄": "face with rolling eyes",
  "😬": "grimacing grimacing face",
  "😮‍💨": "face exhaling",
  "🤥": "lying face",
  "😌": "relieved relieved face",
  "😔": "pensive pensive face",
  "😪": "sleepy sleepy face",
  "🤤": "drooling face",
  "😴": "sleeping sleeping face",
  "😷": "mask face with medical mask",
  "🤒": "face with thermometer",
  "🤕": "face with head-bandage face with head bandage",
  "🤢": "nauseated face",
  "🤮": "face vomiting face with open mouth vomiting",
  "🤧": "sneezing face",
  "🥵": "hot face overheated face",
  "🥶": "cold face freezing face",
  "🥴": "woozy face face with uneven eyes and wavy mouth",
  "😵": "dizzy face",
  "😵‍💫": "face with spiral eyes",
  "🤯": "exploding head shocked face with exploding head",
  "🤠": "face with cowboy hat",
  "🥳": "partying face face with party horn and party hat",
  "🥸": "disguised face",
  "😎": "sunglasses smiling face with sunglasses",
  "🤓": "nerd face",
  "🧐": "face with monocle",
  "🐶": "dog dog face",
  "🐱": "cat cat face",
  "🐭": "mouse mouse face",
  "🐹": "hamster hamster face",
  "🐰": "rabbit rabbit face",
  "🦊": "fox face",
  "🐻": "bear bear face",
  "🐼": "panda face",
  "🐨": "koala",
  "🐯": "tiger tiger face",
  "🦁": "lion face",
  "🐮": "cow cow face",
  "🐷": "pig pig face",
  "🐸": "frog frog face",
  "🐵": "monkey face",
  "🐔": "chicken",
  "🐧": "penguin",
  "🐦": "bird",
  "🐤": "baby chick",
  "🦆": "duck",
  "🦅": "eagle",
  "🦉": "owl",
  "🦇": "bat",
  "🐺": "wolf wolf face",
  "🐗": "boar",
  "🐴": "horse horse face",
  "🦄": "unicorn face",
  "🐝": "bee honeybee",
  "🪱": "worm",
  "🐛": "bug",
  "🦋": "butterfly",
  "🐌": "snail",
  "🐞": "ladybug lady beetle",
  "🐜": "ant",
  "🪰": "fly",
  "🪲": "beetle",
  "🪳": "cockroach",
  "🦟": "mosquito",
  "🦗": "cricket",
  "🌸": "cherry blossom",
  "🌺": "hibiscus",
  "🌻": "sunflower",
  "🌷": "tulip",
  "🌹": "rose",
  "🥀": "wilted flower",
  "🌲": "evergreen tree",
  "🌳": "deciduous tree",
  "🌴": "palm tree",
  "🌱": "seedling",
  "🌿": "herb",
  "🍀": "four leaf clover",
  "🍃": "leaves leaf fluttering in wind",
  "🍂": "fallen leaf",
  "🍁": "maple leaf",
  "🪴": "potted plant",
  "🍎": "apple red apple",
  "🍊": "tangerine",
  "🍋": "lemon",
  "🍌": "banana",
  "🍉": "watermelon",
  "🍇": "grapes",
  "🍓": "strawberry",
  "🫐": "blueberries",
  "🍈": "melon",
  "🍒": "cherries",
  "🍑": "peach",
  "🥭": "mango",
  "🍍": "pineapple",
  "🥥": "coconut",
  "🥝": "kiwifruit",
  "🍅": "tomato",
  "🥑": "avocado",
  "🍆": "eggplant aubergine",
  "🥔": "potato",
  "🥕": "carrot",
  "🌽": "corn ear of maize",
  "🥒": "cucumber",
  "🥬": "leafy green",
  "🫑": "bell pepper",
  "🥦": "broccoli",
  "🧄": "garlic",
  "🧅": "onion",
  "🍄": "mushroom",
  "🥜": "peanuts",
  "🫘": "beans",
  "🍞": "bread",
  "🥐": "croissant",
  "🥖": "baguette bread",
  "🥨": "pretzel",
  "🧀": "cheese wedge",
  "🥚": "egg",
  "🍳": "cooking fried egg",
  "🥓": "bacon",
  "🥞": "pancakes",
  "🧇": "waffle",
  "🍗": "poultry leg",
  "🍖": "meat on bone",
  "🍕": "pizza slice of pizza",
  "🍔": "hamburger",
  "🌭": "hotdog hot dog",
  "🥪": "sandwich",
  "🌮": "taco",
  "🌯": "burrito",
  "🫔": "tamale",
  "🥙": "stuffed flatbread",
  "🧆": "falafel",
  "🍿": "popcorn",
  "🧈": "butter",
  "🧂": "salt salt shaker",
  "☕": "coffee hot beverage",
  "🍵": "tea teacup without handle",
  "🥤": "cup with straw",
  "🧃": "beverage box",
  "🧋": "bubble tea",
  "🍺": "beer beer mug",
  "⚽": "soccer soccer ball",
  "🏀": "basketball basketball and hoop",
  "🏈": "football american football",
  "⚾": "baseball",
  "🥎": "softball",
  "🎾": "tennis tennis racquet and ball",
  "🏐": "volleyball",
  "🏉": "rugby football",
  "🥏": "flying disc",
  "🎱": "8ball billiards",
  "🪀": "yo-yo",
  "🏓": "table tennis paddle and ball",
  "🏸": "badminton racquet and shuttlecock",
  "🏒": "ice hockey stick and puck",
  "🏑": "field hockey stick and ball",
  "🥍": "lacrosse lacrosse stick and ball",
  "🏏": "cricket bat and ball",
  "🪃": "boomerang",
  "🥅": "goal net",
  "⛳": "golf flag in hole",
  "🪁": "kite",
  "🏹": "bow and arrow",
  "🎣": "fishing pole and fish",
  "🤿": "diving mask",
  "🥊": "boxing glove",
  "🥋": "martial arts uniform",
  "🎽": "running shirt with sash",
  "🛹": "skateboard",
  "🛼": "roller skate",
  "🛷": "sled",
  "🥌": "curling stone",
  "🎿": "ski ski and ski boot",
  "🏂": "snowboarder",
  "🪂": "parachute",
  "🤼": "wrestlers",
  "🤸": "person doing cartwheel",
  "🤺": "fencer",
  "🤾": "handball",
  "🏇": "horse racing",
  "🧘": "person in lotus position",
  "🏄": "surfer",
  "🏊": "swimmer",
  "🤽": "water polo",
  "🚣": "rowboat",
  "🧗": "person climbing",
  "🚴": "bicyclist",
  "🚵": "mountain bicyclist",
  "🎯": "dart direct hit",
  "🎮": "video game",
  "🎰": "slot machine",
  "🎲": "game die",
  "🧩": "jigsaw jigsaw puzzle piece",
  "🎭": "performing arts",
  "🎨": "art artist palette",
  "🚗": "car red car automobile",
  "🚕": "taxi",
  "🚙": "blue car recreational vehicle",
  "🚌": "bus",
  "🚎": "trolleybus",
  "🚓": "police car",
  "🚑": "ambulance",
  "🚒": "fire engine",
  "🚐": "minibus",
  "🛻": "pickup truck",
  "🚚": "truck delivery truck",
  "🚛": "articulated lorry",
  "🚜": "tractor",
  "🛵": "motor scooter",
  "🛺": "auto rickshaw",
  "🚲": "bike bicycle",
  "🛴": "scooter",
  "🚏": "busstop bus stop",
  "⛽": "fuelpump fuel pump",
  "🚨": "rotating light police cars revolving light",
  "🚥": "traffic light horizontal traffic light",
  "🚦": "vertical traffic light",
  "🛑": "octagonal sign",
  "🚧": "construction construction sign",
  "⚓": "anchor",
  "⛵": "boat sailboat",
  "🛶": "canoe",
  "🚤": "speedboat",
  "🚢": "ship",
  "🛫": "airplane departure",
  "🛬": "airplane arriving",
  "💺": "seat",
  "🚁": "helicopter",
  "🚟": "suspension railway",
  "🚠": "mountain cableway",
  "🚡": "aerial tramway",
  "🚀": "rocket",
  "🛸": "flying saucer",
  "🏠": "house house building",
  "🏡": "house with garden",
  "🏢": "office office building",
  "🏣": "post office japanese post office",
  "🏤": "european post office",
  "🏥": "hospital",
  "🏦": "bank",
  "🏨": "hotel",
  "🏩": "love hotel",
  "🏪": "convenience store",
  "🏫": "school",
  "⌚": "watch",
  "📱": "iphone mobile phone",
  "📲": "calling mobile phone with rightwards arrow at left",
  "💻": "computer personal computer",
  "💾": "floppy disk",
  "💿": "cd optical disc",
  "📀": "dvd",
  "📼": "vhs videocassette",
  "📷": "camera",
  "📸": "camera with flash",
  "📹": "video camera",
  "🎥": "movie camera",
  "📞": "telephone receiver",
  "📟": "pager",
  "📠": "fax fax machine",
  "📺": "tv television",
  "📻": "radio",
  "🧭": "compass",
  "⏰": "alarm clock",
  "⌛": "hourglass",
  "⏳": "hourglass flowing sand hourglass with flowing sand",
  "📡": "satellite antenna",
  "🔋": "battery",
  "🔌": "electric plug",
  "💡": "bulb electric light bulb",
  "🔦": "flashlight electric torch",
  "🪔": "diya lamp",
  "🧯": "fire extinguisher",
  "💸": "money with wings",
  "💵": "dollar banknote with dollar sign",
  "💴": "yen banknote with yen sign",
  "💶": "euro banknote with euro sign",
  "💷": "pound banknote with pound sign",
  "🪙": "coin",
  "💰": "moneybag money bag",
  "💳": "credit card",
  "💎": "gem gem stone",
  "🪜": "ladder",
  "🧰": "toolbox",
  "🪛": "screwdriver",
  "🔧": "wrench",
  "📚": "books",
  "📖": "book open book",
  "📝": "memo pencil",
  "📔": "notebook with decorative cover",
  "📕": "closed book",
  "📗": "green book",
  "🧡": "orange heart",
  "💛": "yellow heart",
  "💚": "green heart",
  "💙": "blue heart",
  "💜": "purple heart",
  "🖤": "black heart",
  "🤍": "white heart",
  "🤎": "brown heart",
  "💔": "broken heart",
  "🔥": "fire",
  "💕": "two hearts",
  "💞": "revolving hearts",
  "💓": "heartbeat beating heart",
  "💗": "heartpulse growing heart",
  "💖": "sparkling heart",
  "💘": "cupid heart with arrow",
  "💝": "gift heart heart with ribbon",
  "💟": "heart decoration",
  "🔯": "six pointed star six pointed star with middle dot",
  "🕎": "menorah with nine branches",
  "🛐": "place of worship",
  "♈": "aries",
  "♉": "taurus",
  "♊": "gemini",
  "♋": "cancer",
  "♌": "leo",
  "♍": "virgo",
  "♎": "libra",
  "♏": "scorpius",
  "♐": "sagittarius",
  "♑": "capricorn",
  "♒": "aquarius",
  "♓": "pisces",
  "⛎": "ophiuchus",
  "🔀": "twisted rightwards arrows",
  "🔁": "repeat clockwise rightwards and leftwards open circle arrows",
  "🔂": "repeat one clockwise rightwards and leftwards open circle arrows with circled one overlay",
  "⏩": "fast forward black right-pointing double triangle",
  "⭐": "star white medium star",
  "🌟": "star2 glowing star",
  "✨": "sparkles",
  "⚡": "zap high voltage sign",
  "💥": "boom collision collision symbol",
  "💫": "dizzy dizzy symbol",
  "🌈": "rainbow",
  "🌙": "crescent moon",
};
